import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminSpamVariants from "@/pages/admin/AdminSpamVariants";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/spam-variants")({
  head: () => adminHead("Whitelist Variants | Admin", "Inspect spam whitelist variant overlap and sample coverage.", "/admin/spam-variants"),
  component: () => (
    <ProtectedRoute>
      <AdminSpamVariants />
    </ProtectedRoute>
  ),
});
